/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Upload_Files_For_Ai_To_StudyInputs */

const en_upload_files_for_ai_to_study = /** @type {(inputs: Upload_Files_For_Ai_To_StudyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload files for AI to study`)
};

const es_upload_files_for_ai_to_study = /** @type {(inputs: Upload_Files_For_Ai_To_StudyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sube archivos para que la IA los estudie`)
};

const fr_upload_files_for_ai_to_study = /** @type {(inputs: Upload_Files_For_Ai_To_StudyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uploader des fichiers pour que l'IA les étudie`)
};

const de_upload_files_for_ai_to_study = /** @type {(inputs: Upload_Files_For_Ai_To_StudyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dateien für die KI zum Studieren hochladen`)
};

const ja_upload_files_for_ai_to_study = /** @type {(inputs: Upload_Files_For_Ai_To_StudyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AIに学習させるためのファイルをアップロード`)
};

const zh_upload_files_for_ai_to_study = /** @type {(inputs: Upload_Files_For_Ai_To_StudyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上传供 AI 学习的文件`)
};

const ar_upload_files_for_ai_to_study = /** @type {(inputs: Upload_Files_For_Ai_To_StudyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`رفع ملفات ليدرسها الذكاء الاصطناعي`)
};

const id_upload_files_for_ai_to_study = /** @type {(inputs: Upload_Files_For_Ai_To_StudyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unggah file untuk dipelajari AI`)
};

const it_upload_files_for_ai_to_study = /** @type {(inputs: Upload_Files_For_Ai_To_StudyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carica i file affinché l'IA li studi`)
};

const ru_upload_files_for_ai_to_study = /** @type {(inputs: Upload_Files_For_Ai_To_StudyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузите файлы для изучения ИИ`)
};

const pt_upload_files_for_ai_to_study = /** @type {(inputs: Upload_Files_For_Ai_To_StudyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faça upload de arquivos para a IA estudar`)
};

const ko_upload_files_for_ai_to_study = /** @type {(inputs: Upload_Files_For_Ai_To_StudyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 학습용 파일 업로드`)
};

/**
* | output |
* | --- |
* | "Upload files for AI to study" |
*
* @param {Upload_Files_For_Ai_To_StudyInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const upload_files_for_ai_to_study = /** @type {((inputs?: Upload_Files_For_Ai_To_StudyInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Upload_Files_For_Ai_To_StudyInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_upload_files_for_ai_to_study(inputs)
	if (locale === "es") return es_upload_files_for_ai_to_study(inputs)
	if (locale === "fr") return fr_upload_files_for_ai_to_study(inputs)
	if (locale === "de") return de_upload_files_for_ai_to_study(inputs)
	if (locale === "ja") return ja_upload_files_for_ai_to_study(inputs)
	if (locale === "zh") return zh_upload_files_for_ai_to_study(inputs)
	if (locale === "ar") return ar_upload_files_for_ai_to_study(inputs)
	if (locale === "id") return id_upload_files_for_ai_to_study(inputs)
	if (locale === "it") return it_upload_files_for_ai_to_study(inputs)
	if (locale === "ru") return ru_upload_files_for_ai_to_study(inputs)
	if (locale === "pt") return pt_upload_files_for_ai_to_study(inputs)
	return ko_upload_files_for_ai_to_study(inputs)
});